import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { Button, Column, H1, IconButton, Modal, Row } from "@revoltchat/ui";

import { UserButton } from "../../../components/navigation/items/ButtonItem";
import { ModalProps } from "../types";

const CalledByUserTitle = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export function CalledByUser(props: ModalProps<"called_by_user">) {
    const history = useHistory();

    async function toCall() {
        const dm = await props.user.openDM();
        if (!dm) {
            return;
        }

        props.onClose();
        history.push(dm.path);
    }

    return (
        <Modal
            signal={props.signal}
            onClose={props.onClose}
            nonDismissable
            title={
                <CalledByUserTitle>
                    <H1>Вызов от</H1>
                    <UserButton user={props.user} />
                </CalledByUserTitle>
            }
            actions={[
                {
                    onClick: toCall,
                    confirmation: true,
                    children: "Перейти к звонку",
                },
                {
                    onClick: props.onClose,
                    children: "Отмена",
                },
            ]}>
            {/* <Row centered>
        <Button onClick={toCall}>
          Перейти
        </Button>
        <Button onClick={props.onClose}>
          Отмена
        </Button>
      </Row> */}
        </Modal>
    );
}
